import Vue from 'vue'
import hasPermis from './hasPermis'
const install = function (Vue) {
  Vue.directive('hasPermi', hasPermis)
}

if (window.Vue) {
  window.hasPermi = hasPermis
}
Vue.use(install)

export default install
